import {
  Avatar,
  Box,
  Button,
  Card,
  CardHeader,
  Grid,
  IconButton,
  ImageList,
  ImageListItem,
  ImageListItemBar,
  ListItem,
  ListItemText,
  Stack,
  TextField,
  Typography
} from "@mui/material";
import { LocalizationProvider, MobileTimePicker } from "@mui/x-date-pickers";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import ArrowDropUpIcon from "@mui/icons-material/ArrowDropUp";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import AddIcon from "@mui/icons-material/Add";
import HelpIcon from "@mui/icons-material/Help";
import CloseIcon from "@mui/icons-material/Close";
import BusinessCenterIcon from "@mui/icons-material/BusinessCenter";
import DoNotDisturbOnIcon from "@mui/icons-material/DoNotDisturbOn";
import { setShowalert } from "../../../redux/actions/actions";
import { useDispatch } from "react-redux";
import { getFormattedAddress } from "../../common/GetFormattedAddress";
import ImageIcon from "@mui/icons-material/Image";
import { useSelector } from "react-redux";
import { English } from "../../../constant/EnglishFallback";
import dayjs from "dayjs";
import PlaceholderImg from "../../../assets/images/placeholder_img.jpg";
import { useState } from "react";

const convertToDecimal = (timeString) => {
  const [hours, minutes] = timeString.split(":").map(Number);
  return `${hours}.${minutes.toString().padStart(2, "0")}`;
};

const formatNumericToTime = (numericValue) => {
  if (numericValue === undefined || numericValue === null) {
    return "00:00";
  }

  let formattedHours = "00";
  let formattedMinutes = "00";
  let finaltime = "00";

  if (numericValue.toString().includes(".")) {
    let [hoursPart, minutesPart] = numericValue.toString().split(".");

    if (hoursPart !== 0) {
      const hours = parseInt(hoursPart) || 0;
      const minutes = minutesPart;
      formattedHours = hours.toString().padStart(2, "0");
      formattedMinutes =
        minutes.toString().length === 1 ? minutes.toString().padEnd(2, "0") : minutes;
      finaltime = `${formattedHours}:${formattedMinutes}`;
    } else {
      formattedMinutes =
        minutesPart.toString().length === 1
          ? `00:${minutesPart.toString().padEnd(2, "0")}`
          : `00:${minutesPart}`;
      finaltime = `${formattedMinutes}`;
    }
  } else {
    let hoursPart = numericValue.toString();
    formattedHours =
      hoursPart.length === 1
        ? `${hoursPart.toString().padStart(2, "0")}:00`
        : hoursPart.length === 2
          ? `${hoursPart}:00`
          : hoursPart;
    finaltime = `${formattedHours}`;
  }

  return `${finaltime}`;
};

const AddJobTimesheet = ({ 
  selectedJob, 
  setSelectedJob, 
  goallist, 
  userGoalData, 
  loginData,
  isSmallScreen = false,
  disabled = false,
  onGoalModalOpen,
  onPictureViewerOpen,
  onTotalTimeChange,
  onTotalDistanceChange,
  roleIndex = 1,
  deletedEntries,
  setDeletedEntries,
  deletedImages,
  setDeletedImages,
  deletedGoalsCategories,
  setDeletedGoalsCategories,
}) => {
  const dispatch = useDispatch();

  // Self-managed state (moved from context)
  const [indexForGoal, setIndexForGoal] = useState(0);
  const [goalIndex, setGoalIndex] = useState(0);

  const { multiLanguageData } = useSelector((state) => state?.main);
  const LanguageData = multiLanguageData?.TimeSheet || {};
  const {
    TEXT_JOB_START = English.TimeSheet.TEXT_JOB_START,
    TEXT_REQUIRED = English.TimeSheet.TEXT_REQUIRED,
    TEXT_DISTANCE = English.TimeSheet.TEXT_DISTANCE,
    TEXT_KM = English.TimeSheet.TEXT_KM,
    TEXT_MI = English.TimeSheet.TEXT_MI,
    TEXT_ADD_GOAL = English.TimeSheet.TEXT_ADD_GOAL,
    TEXT_COMMENTS_PLACEHOLDER = English.TimeSheet.TEXT_COMMENTS_PLACEHOLDER,
    TEXT_ADD_PICTURES = English.TimeSheet.TEXT_ADD_PICTURES,
    TEXT_NO_COMPANY = English.TimeSheet.TEXT_NO_COMPANY,
    TEXT_GOAL_CREDIT_WARNING = English.TimeSheet.TEXT_GOAL_CREDIT_WARNING
  } = LanguageData || {};

  const handleCommentChange = (e, index) => {
    if (disabled) return;
    
    let inputValue = e.target.value;
    inputValue = inputValue.replace(/^[^A-Za-z0-9]+/, "");
    const updatedJobs = [...selectedJob];
    updatedJobs[index].comments = inputValue;
    setSelectedJob(updatedJobs);
  };

  const subtractTime = (time1, time2) => {
    const [hours1, minutes1] = time1.split(":").map((s) => parseInt(s, 10));
    const [hours2, minutes2] = time2.split(":").map((s) => parseInt(s, 10));
    let hours = hours1 - hours2;
    let minutes = minutes1 - minutes2;
    if (minutes < 0) {
      minutes += 60;
      hours -= 1;
    }
    if (hours < 0) {
      hours += 24;
    }
    const formattedHours = hours.toString().padStart(2, "0");
    const formattedMinutes = minutes.toString().padStart(2, "0");
    return `${formattedHours}:${formattedMinutes}`;
  };

  const removeCurrentTimesheet = (item, index) => {
    if (disabled) return;
    console.log('deletedEntries',deletedEntries)
    console.log('item==>',item)
    
    if (!item.isDeleted && !item.isNew) {
      setDeletedEntries([...deletedEntries, item]);
    }

    const newEntriesData = selectedJob.filter((entry, i) => i !== index);
    setSelectedJob(newEntriesData);

    // Calculate new totals and notify parent
    updateTotalTime(newEntriesData);
    updateTotalDistance(newEntriesData);
  };

  const openImage = (parentIndex) => {
    if (disabled) return;
    
    setSelectedJob((prevJobs) =>
      prevJobs.map((item, index) => ({
        ...item,
        isShowimage: parentIndex === index ? !item.isShowimage : false
      }))
    );
    setIndexForGoal(parentIndex);
  };

  const deleteTimeSheetGoal = (entiresDataIndex, goalIndex) => {
    if (disabled) return;
    
    const deletedGoal = selectedJob[entiresDataIndex]?.timesheetGoalsArray.filter(
      (v, i) => i === goalIndex
    );
    setDeletedGoalsCategories([...deletedGoalsCategories, deletedGoal[0]]);
    const remaningGoalData = selectedJob[entiresDataIndex]?.timesheetGoalsArray.filter(
      (v, i) => i !== goalIndex
    );
    let data = [...selectedJob];
    data[entiresDataIndex].timesheetGoalsArray = remaningGoalData ?? [];
    setSelectedJob(data);
  };

  const onDeletePicturePressed = (picItem, picIndex, entiresDataIndex) => {
    if (disabled) return;
    
    if (picItem?.id) {
      setDeletedImages([...deletedImages, picItem]);
    }
    const remaningPictureList = selectedJob[entiresDataIndex]?.pictureList?.filter(
      (pic, i) => i !== picIndex
    );
    let data = [...selectedJob];
    data[entiresDataIndex].pictureList = remaningPictureList ?? [];
    setSelectedJob(data ?? []);
  };

  const onPictureSelect = (pictures, entriesDataIndex) => {
    if (disabled) return;
    
    let data = [...selectedJob];
    if (!data[entriesDataIndex].pictureList) {
      data[entriesDataIndex].pictureList = [];
    }
    data[entriesDataIndex].pictureList = [...data[entriesDataIndex].pictureList, ...pictures];
    setSelectedJob(data);
  };

  function handleChooseFile(event, index) {
    if (disabled) return;
    
    const files = event.target.files;
    const pictures = [];
    let allFilesValid = true;
    
    if (files?.length > 0) {
      for (let i = 0; i < files.length; i++) {
        if (!files[i].type.startsWith("image/")) {
          allFilesValid = false;
          break;
        }
      }
    }
    
    if (!allFilesValid) {
      return alert("Please select valid image files (JPEG, PNG, GIF, etc.).");
    }
    
    Array.from(files).forEach((file) => pictures.push(file));
    onPictureSelect(pictures, index);
    event.target.value = null;
  }

  const handleRowClick = (value) => {
    if (disabled) return;
    
    let data = [...selectedJob];
    data[value.itemIndex].isJobItemAddGoalClicked = false;
    setGoalIndex(value?.goalIndex);
    setIndexForGoal(value?.itemIndex);
    setSelectedJob(data);
    
    if (onGoalModalOpen) {
      onGoalModalOpen();
    }
  };

  const onAddGoalClick = async (item, indexForGoal) => {
    if (disabled) return;
    
    let data = [...selectedJob];
    data[indexForGoal].isJobItemAddGoalClicked = true;
    await setIndexForGoal(indexForGoal);
    await setSelectedJob(data);
    
    if (onGoalModalOpen) {
      onGoalModalOpen();
    }
    return;
  };

  const handleTimeChange = (newValue, index) => {
    if (!newValue || disabled) return;

    const updatedJobs = [...selectedJob];
    const formattedTime = newValue.format("HH:mm");
    const decimalTime = convertToDecimal(formattedTime);
    updatedJobs[index].hours = decimalTime;

    setSelectedJob(updatedJobs);
    updateTotalTime(updatedJobs);
  };

  const handleShowAlert = () => {
    let alertObj = {
      showAlert: true,
      title: "",
      text: TEXT_GOAL_CREDIT_WARNING
    };
    dispatch(setShowalert(alertObj));
  };

  const updateTotalTime = (jobs) => {
    if (!jobs || jobs.length === 0) {
      if (onTotalTimeChange) {
        onTotalTimeChange("00:00");
      }
      return;
    }

    let totalHours = 0;
    let totalMinutes = 0;

    jobs.forEach((job) => {
      if (job.hours !== 0) {
        const formattedTime = formatNumericToTime(job?.hours);
        const [hours, minutes] = formattedTime.split(":").map((s) => parseInt(s, 10));

        if (!isNaN(hours) && !isNaN(minutes)) {
          totalHours += hours;
          totalMinutes += minutes;
        }
      }
    });

    totalHours += Math.floor(totalMinutes / 60);
    totalMinutes %= 60;

    const formattedTotalTime = `${String(totalHours).padStart(2, "0")}:${String(
      totalMinutes
    ).padStart(2, "0")}`;

    if (onTotalTimeChange) {
      onTotalTimeChange(formattedTotalTime);
    }
  };

  const updateTotalDistance = (jobs) => {
    const totalDistance = jobs.reduce(
      (sum, job) => (job.distance > 0 ? sum + job.distance : sum),
      0
    );

    if (onTotalDistanceChange) {
      onTotalDistanceChange(totalDistance);
    }
  };

  const getAddress = (params) => {
    const userAddress = {
      city: params?.siteCity,
      country: params?.siteCountry,
      province: params?.siteProvince,
      postalCode: params?.sitePostalCode,
      address: params?.siteAddress
    };
    let { city, country, province, postalCode, address, address1 } = userAddress ? userAddress : {};
    city =
      city !== "" && city
        ? city.replace(/\w*/g, (txt) => txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase())
        : "";
    country =
      country !== "" && country
        ? country.replace(
            /\w*/g,
            (txt) => txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase()
          )
        : "";

    const uAddress = getFormattedAddress(
      address ?? "",
      address1 ?? "",
      city ?? "",
      province ?? "",
      country ?? "",
      postalCode ?? "",
      3
    );
    return uAddress;
  };

  return (
    <Box sx={{ height: "350px", overflow: "auto", scrollbarWidth: "none" }}>
      <Stack spacing={1.5}>
        {selectedJob.length === 0 ? (
          <div className="add-job-modal-body">
            <BusinessCenterIcon className="add-job-modal-body-icon" />
            <Typography variant="body2" sx={{ color: "gray", textAlign: "center" }}>
              {TEXT_JOB_START}
            </Typography>
          </div>
        ) : (
          selectedJob.map((item, index) => (
            <Card
              key={index}
              className="pagelist-content"
              sx={{ p: 2, mt: 0 }}>
              <Typography variant="h6">
                {item?.companyId === 0 || item?.companyName === ""
                  ? TEXT_NO_COMPANY
                  : item.companyName}
              </Typography>

              <CardHeader
                action={
                  <IconButton
                    size="medium"
                    aria-label="settings"
                    onClick={() => removeCurrentTimesheet(item, index)}
                    disabled={disabled}>
                    <CloseIcon fontSize="small" />
                  </IconButton>
                }
                sx={{ p: 0, pt: 1 }}
                title={
                  <ListItem disablePadding alignItems="flex-start">
                    <Avatar
                      className="add-Timesheet-picture"
                      variant="square"
                      alt="contact-PictureUrl"
                      src={item?.mainPictureUrl || item?.projectPictures || PlaceholderImg}
                    />
                    <ListItemText
                      sx={{ pl: 2, mt: 0 }}
                      primary={
                        <Typography variant="body1" maxWidth={"430px"} noWrap>
                          {item?.projectName}
                        </Typography>
                      }
                      secondary={
                        <Box>
                          <Typography variant="body2" maxWidth={"430px"} noWrap>
                            {item?.siteName}
                          </Typography>
                          <Typography variant="body2" maxWidth={"430px"} noWrap>
                            {getAddress(item)}
                          </Typography>
                        </Box>
                      }
                    />
                  </ListItem>
                }
              />

              <Grid sx={{ pt: 2 }} container spacing={1} size={12}>
                <Grid size={11}>
                  <Stack direction="row" sx={{ alignItems: "center" }} spacing={1.5}>
                    <Stack width={"120px"}>
                      <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <MobileTimePicker
                          format="HH:mm"
                          value={
                            item?.hours === 0
                              ? dayjs("00:00", "HH:mm")
                              : dayjs(formatNumericToTime(item?.hours), "HH:mm")
                          }
                          onChange={(newValue) => handleTimeChange(newValue, index)}
                          disabled={disabled}
                          ampm={false}
                          sx={{
                            justifyContent: "center",
                            borderRadius: "10px",
                            "& .MuiOutlinedInput-root": {
                              padding: "0px",
                              paddingLeft: "0px"
                            }
                          }}
                        />
                      </LocalizationProvider>
                    </Stack>
                    <Stack width={"120px"}>
                      <Typography>({TEXT_REQUIRED})</Typography>
                    </Stack>

                    <Stack direction="column" spacing={1} width={"120px"}>
                      <TextField
                        label={TEXT_DISTANCE}
                        type="number"
                        value={item.distance || ""}
                        disabled={disabled}
                        onChange={(e) => {
                          let value = e.target.value;
                          if (value.length > 4) return;
                          const newDistance = value === "" ? "" : Math.max(0, parseFloat(value));
                          const updatedJobs = [...selectedJob];
                          updatedJobs[index].distance = newDistance;
                          setSelectedJob(updatedJobs);
                          
                          updateTotalDistance(updatedJobs);
                        }}
                        slotProps={{ max: 1 }}
                        inputProps={{
                          maxLength: 4
                        }}
                        onKeyDown={(e) => {
                          if (["e", "E", "+", "-"].includes(e.key)) {
                            e.preventDefault();
                          }
                        }}
                      />
                    </Stack>
                    <Stack direction="column" spacing={1}>
                      <Typography>{""}</Typography>
                      <Typography variant="body1">{roleIndex === 2 ? TEXT_MI : TEXT_KM}</Typography>
                    </Stack>
                  </Stack>
                </Grid>

                <Grid size={1}>
                  <Stack sx={{ display: "flex", justifyContent: "center" }}>
                    <IconButton onClick={() => openImage(index)} disabled={disabled}>
                      {item?.isShowimage ? <ArrowDropUpIcon /> : <ArrowDropDownIcon />}
                    </IconButton>
                  </Stack>
                </Grid>
              </Grid>

              {item?.isShowimage && (
                <Stack spacing={1.5} sx={{ pt: 1.5 }}>
                  {item?.timesheetGoalsArray?.map((goalItem, goalIndex) => (
                    <Stack sx={{ alignItems: "center", margin: "5px 0" }} key={goalIndex} direction="row" spacing={2}>
                      <IconButton
                        color="secondary"
                        onClick={() => {
                          deleteTimeSheetGoal(indexForGoal, goalIndex);
                        }}
                        disabled={disabled}>
                        <DoNotDisturbOnIcon />
                      </IconButton>
                      <Stack
                        direction="row"
                        spacing={2}
                        sx={{
                          borderRadius: "5px",
                          border: "1px solid",
                          borderColor: "lightgray",
                          padding: "15px",
                          cursor: disabled ? "default" : "pointer",
                          width: "100%",
                          justifyContent: "space-between",
                          opacity: disabled ? 0.6 : 1
                        }}
                        onClick={() =>
                          !disabled && handleRowClick({
                            goalItem: goalItem,
                            goalIndex: goalIndex,
                            itemIndex: indexForGoal,
                            item: item
                          })
                        }>
                        <Typography>{goalItem?.goalName || goalItem?.categoryName}</Typography>
                        <ArrowDropDownIcon />
                      </Stack>
                      <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <MobileTimePicker
                          format="HH:mm"
                          value={
                            goalItem?.time === 0
                              ? dayjs("00:00", "HH:mm")
                              : dayjs(formatNumericToTime(goalItem?.time), "HH:mm")
                          }
                          onChange={(newValue) => {
                            if (newValue && !disabled) {
                              const updatedJobs = [...selectedJob];
                              const decimalTime = convertToDecimal(newValue.format("HH:mm"));
                              updatedJobs[indexForGoal].timesheetGoalsArray[goalIndex].time =
                                decimalTime;
                              setSelectedJob(updatedJobs);
                            }
                          }}
                          disabled={disabled}
                          ampm={false}
                          renderInput={(params) => (
                            <TextField
                              size="small"
                              {...params}
                              sx={{
                                width: "120px",
                                marginLeft: 2,
                                "& .MuiOutlinedInput-root": {
                                  borderRadius: "8px"
                                }
                              }}
                              disabled={disabled}
                            />
                          )}
                        />
                      </LocalizationProvider>
                    </Stack>
                  ))}

                  {goallist?.length > 0 && (
                    <Stack direction="row" sx={{ marginTop: 2,  alignItems: "center" }} spacing={2} >
                      <Button
                        startIcon={<AddIcon />}
                        variant="contained"
                        size="small"
                        disabled={disabled}
                        onClick={() => {
                          onAddGoalClick(item, indexForGoal);
                        }}>
                        {TEXT_ADD_GOAL}
                      </Button>
                      <IconButton onClick={() => handleShowAlert()} disabled={disabled}>
                        <HelpIcon />
                      </IconButton>
                    </Stack>
                  )}

                  <TextField
                    label={TEXT_COMMENTS_PLACEHOLDER}
                    multiline
                    rows={2}
                    fullWidth
                    value={item?.comments || ""}
                    disabled={disabled}
                    onChange={(e) => handleCommentChange(e, index)}
                  />

                  {item?.pictureList?.length !== 0 ? (
                    <>
                      <Box sx={{ flexGrow: 1 }}>
                        <Grid container spacing={1} sx={{ alignItems: "center" }}>
                          <Grid
                            size={{ xs: 4, sm: 3, md: 3 }}
                            sx={{ height: isSmallScreen ? 90 : 130 }}>
                            <Button
                              sx={{
                                width: "100%",
                                height: "100%",
                                color: "GrayText",
                                borderRadius: "10px",
                                backgroundColor: "lightgray",
                                boxShadow: "none",
                                textAlign: "center",
                                p: 0
                              }}
                              variant="text"
                              size="small"
                              component="label"
                              disabled={disabled}>
                              <ImageIcon /> {TEXT_ADD_PICTURES}
                              <input
                                id="timeSheetPicture-upload"
                                type="file"
                                multiple
                                accept="image/*"
                                onChange={(e) => handleChooseFile(e, index)}
                                hidden
                                disabled={disabled}
                              />
                            </Button>
                          </Grid>

                          <Grid
                            size={{ xs: 8, sm: 9, md: 9 }}
                            sx={{ height: isSmallScreen ? 90 : 130 }}>
                            <ImageList
                              gap={7.5}
                              sx={{
                                width: "100%",
                                height: "100%",
                                margin: 0,
                                padding: 0,
                                flexWrap: "nowrap",
                                overflowX: "auto",
                                display: "flex",
                                scrollbarWidth: "none",
                                borderRadius: "10px",
                                backgroundColor: "white"
                              }}>
                              {item?.pictureList.map((picItem, picIndex) => (
                                <ImageListItem
                                  key={picIndex}
                                  sx={{ minWidth: isSmallScreen ? 90 : 130 }}>
                                  <img
                                    src={
                                      picItem?.pictureUrl
                                        ? picItem?.pictureUrl
                                        : URL.createObjectURL(picItem)
                                    }
                                    style={{
                                      borderRadius: 10,
                                      width: isSmallScreen ? 90 : 130,
                                      height: isSmallScreen ? 90 : 130,
                                      objectFit: "cover",
                                      cursor: disabled ? "default" : "pointer"
                                    }}
                                    alt="Expenses"
                                    loading="lazy"
                                    onClick={() => {
                                      if (!disabled && onPictureViewerOpen) {
                                        onPictureViewerOpen(item?.pictureList, picIndex);
                                      }
                                    }}
                                  />
                                  <ImageListItemBar
                                    sx={{ background: "none", padding: 1 }}
                                    position="top"
                                    actionIcon={
                                      <IconButton
                                        onClick={() =>
                                          onDeletePicturePressed(picItem, picIndex, index)
                                        }
                                        size="small"
                                        disabled={disabled}
                                        sx={{
                                          color: "white",
                                          backgroundColor: "rgba(0,0,0,0.3)"
                                        }}>
                                        <CloseIcon fontSize="small" />
                                      </IconButton>
                                    }
                                    actionPosition="right"
                                  />
                                </ImageListItem>
                            ))}
                          </ImageList>
                        </Grid>
                      </Grid>
                      </Box>
                    </>
                  ) : (
                    <Button
                      sx={{
                        width: "100%",
                        color: "GrayText",
                        height: 100,
                        backgroundColor: "lightgray",
                        boxShadow: "none"
                      }}
                      startIcon={<ImageIcon />}
                      variant="contained"
                      size="small"
                      component="label"
                      disabled={disabled}>
                      {TEXT_ADD_PICTURES}
                      <input
                        id="timeSheetPicture-upload"
                        type="file"
                        multiple
                        accept="image/*"
                        onChange={(e) => handleChooseFile(e, index)}
                        hidden
                        disabled={disabled}
                      />
                    </Button>
                  )}
                </Stack>
              )}
            </Card>
          ))
        )}
      </Stack>
    </Box>
  );
};

export default AddJobTimesheet;
